import { GetPhoenixAtpNode } from '../decoder'

export const makeSetPhoenixAtpNodeEncoder = () => (nodeValue: GetPhoenixAtpNode) => nodeValue
